import angular from "angular";

class JobdescriptionController {
  constructor($timeout, $interval, AuthService, tracking, JobService) {
    this.name = "jobdescription";

    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$tracking = tracking;
    this.$auth = AuthService;
    this.currentUser = this.$auth.getUserData();
    this.$jobs = JobService;
    this.expanded = false;

    this.awaitForGoogleToLoad().then(() => {
      this.geocoder = new window.google.maps.Geocoder();
      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new google.maps.DirectionsRenderer({
        suppressMarkers: true,
      });
    });
  }

  toggleDescription() {
    this.$timeout(() => {
      this.expanded = !this.expanded;
    });
  }

  toggleCompanyDescription() {
    this.$timeout(() => {
      this.expanded_company = !this.expanded_company;
    });
  }

  $onChanges() {
    if (this.jobble) {
      this.$tracking.reportViewJob("job board", this.jobble);

      // TODO: Replace by sending company description in the API
      this.companyDescription = "";
      this.companyName = "";
      let correctDesc;

      this.$jobs.getJobCompanyDesc(this.jobble.id).then((data) => {
        const jobble = data.data;
        correctDesc = data.data.description;
        if (jobble && jobble.subEvent && jobble.subEvent.event && jobble.subEvent.event.company) {
          const company_description = jobble.subEvent.event.company.description;

          this.companyDescription = company_description;
          this.companyName = jobble.subEvent.event.company.name;
          this.jobble.companyLogo = jobble.subEvent.event.company.fileCOMPANY_LOGO1IMG_160x160;

          const length_test = company_description ? company_description.replace(/\W/g, "") : "";

          this.$timeout(() => {
            this.long_company_description = length_test.length > 600;
          });

          this.$timeout(() => {
            this.jobble.description = correctDesc;
          }, 200);
        }
      });

      let descr = !this.jobble.is_partner_post ? this.jobble.description : this.jobble.job_details_no_html || this.jobble.job_parsed_html;
      descr = descr ? descr.replace(/\W/g, "") : "";

      this.$timeout(() => {
        this.long_description = descr.length > 600;
        const panel = document.getElementsByClassName("job-panel-selected")[0];
        if (panel) panel.scrollTop = 0;
        this.shifts = [];
      });

      console.log("SINGLE JOB", this.jobble);

      const job = this.$jobs.processJob(this.jobble).job;

      this.jobble.dressCode = job.dressCode;

      this.$timeout(() => {
        this.shifts = job && job.shifts ? job.shifts : [];

        if (this.shifts.length) {
          this.shifts = this.shifts.sort((a, b) => {
            return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
          });

          this.shifts = this.shifts.map((s) => {
            let start = new Date(moment(s.timeInterval.startTime).format());
            let end = new Date(moment(s.timeInterval.endTime).format());

            let startMoment = moment(start);
            let endMoment = moment(end);

            /*
                        if (startMoment.isDST() === false && moment().isDST() === true) {
                            startMoment.add(1, "hours");
                            endMoment.add(1, "hours");
                        } else if (startMoment.isDST() === true && moment().isDST() === false) {
                            startMoment.subtract(1, "hours");
                            endMoment.subtract(1, "hours");
                        }
                         */

            let timeZone = s.contactInfo.place.timeZoneId;
            //let timeZone = "America/New_York";
            let startDay = startMoment.tz(timeZone).format("M/DD");

            const diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
            const durTime = moment.duration(diffTime);

            const durHours = durTime.hours();
            const durMin = durTime.minutes();

            let unpaidBreaks = s.unpaidBreak;

            const durationInMinutes = durHours * 60 + durMin;
            const payableMinutes = durationInMinutes - unpaidBreaks;

            s.payableHours = Math.floor(payableMinutes / 60);
            s.payableMins = payableMinutes % 60;

            const duration = `${durHours ? durHours + " HR" : ""}${durHours > 1 ? "S" : ""}${durMin && durMin ? " " : ""}${
              durMin ? durMin + "MIN" : ""
            }`;

            return {
              dayOfWeek: startMoment.tz(timeZone).format("ddd"),
              date: startDay,
              startTime: startMoment.tz(timeZone).format("h:mmA"),
              endTime: endMoment.tz(timeZone).format("h:mmA"),
              duration,
              overnight: s.overnight,
              payableHours: s.payableHours,
              payableMins: s.payableMins,
              unpaidBreak: unpaidBreaks,
            };
          });

          this.setTotalHoursToJob(this.shifts);
        }
      });
      //});

      console.log("PROCESSING MAP");

      this.$timeout(() => {
        this.carDistance = null;
        this.walkDistance = null;
        this.transitDistance = null;
        this.expanded = false;
      });

      this.awaitForGoogleToLoad().then(() => {
        this.geocoder = new window.google.maps.Geocoder();
        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer({
          suppressMarkers: true,
        });
        this.loadMap();

        let address;
        if (!this.jobble.is_partner_post) {
          let contactInfo = null;

          if (this.jobble.contactInfo) {
            contactInfo = this.jobble.contactInfo;
          } else {
            contactInfo = this.jobble.subEvent.contactInfo;
          }

          if (contactInfo.zipcode) {
            address = `${contactInfo.streetLine1}, ${contactInfo.city}, ${contactInfo.state} ${contactInfo.zipcode}`;
          } else {
            address = `${contactInfo.streetLine1}, ${contactInfo.city}, ${contactInfo.state}`;
          }
        } else {
          address = `${this.jobble.city}, ${this.jobble.state}`;
        }

        this.$timeout(() => {
          this.address = address;
        });

        this.geocoder.geocode({address: address}, (results, status) => {
          if (status == "OK") {
            // if (this.map) {
            //     this.map.setCenter(results[0].geometry.location);
            //
            //     const marker = new google.maps.Marker({
            //         map: this.map,
            //         position: results[0].geometry.location
            //     });
            //
            //     this.showCurrentLocation(results[0].geometry.location);
            // }
            if (this.maps && this.maps.length) {
              this.maps.forEach((map) => {
                map.setCenter(results[0].geometry.location);

                const marker = new google.maps.Marker({
                  map: map,
                  position: results[0].geometry.location,
                });

                this.showCurrentLocation(results[0].geometry.location, map);
              });
            }
          } else {
            console.log("ERROR WITH GEOCODER :" + status);
            //alert('Geocode was not successful for the following reason: ' + status);
          }
        });
      });
    }
  }

  showCurrentLocation(destination, map) {
    if (navigator.geolocation) {
      if (this.pos) return this.showLocation(this.pos, destination, map);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          this.showLocation(pos, destination, map);
        },
        () => {}
      );
    } else {
      // Browser doesn't support Geolocation
      console.warn("No locator");
    }
  }

  showLocation(pos, destination, map) {
    this.pos = pos;

    const marker = new google.maps.Marker({
      map: map,
      position: pos,
      icon: "http://www.robotwoods.com/dev/misc/bluecircle.png",
    });

    this.directionsRenderer.setMap(map);

    const carRoute = {
      origin: pos,
      destination,
      travelMode: "DRIVING",
    };

    const walkRoute = {
      origin: pos,
      destination,
      travelMode: "WALKING",
    };

    const transitRoute = {
      origin: pos,
      destination,
      travelMode: "TRANSIT",
    };

    this.directionsService.route(carRoute, (response, status) => {
      if (status !== "OK") {
      } else {
        this.directionsRenderer.setDirections(response);
        const directionsData = response.routes[0].legs[0];
        if (!directionsData) {
        } else {
          this.$timeout(() => {
            this.carDistance = directionsData.duration.text.replace("min", "minute");
          });
        }
      }
    });

    this.directionsService.route(walkRoute, (response, status) => {
      if (status !== "OK") {
      } else {
        const directionsData = response.routes[0].legs[0];
        if (!directionsData) {
          this.$timeout(() => {
            this.walkDistance = null;
          });
        } else {
          this.$timeout(() => {
            this.walkDistance = directionsData.duration.text.replace("min", "minute");
          });
        }
      }
    });

    this.directionsService.route(transitRoute, (response, status) => {
      if (status !== "OK") {
      } else {
        const directionsData = response.routes[0].legs[0];
        if (!directionsData) {
          this.$timeout(() => {
            this.transitDistance = null;
          });
        } else {
          this.$timeout(() => {
            this.transitDistance = directionsData.duration.text.replace("min", "minute");
          });
        }
      }
    });
  }

  alreadyApplied() {
    alert("You have already applied to this job!");
  }

  loadMap() {
    var latlng = new google.maps.LatLng(-34.397, 150.644);
    var mapOptions = {
      zoom: 13,
      center: latlng,
      gestureHandling: "cooperative",
    };

    // this.map = new google.maps.Map(document.getElementById('map'), mapOptions);
    this.maps = [];

    Array.from(document.getElementsByClassName("map-google")).forEach((map, index, array) => {
      this.maps.push(new google.maps.Map(map, mapOptions));
    });
  }

  awaitForGoogleToLoad() {
    let count = 0;
    return new Promise((resolve, reject) => {
      if (!angular.isUndefined(window.google)) return resolve();

      const id = Math.floor(Math.random() * 100000);

      this.goggleLoaders = this.goggleLoaders || {};

      this.goggleLoaders[id] = this.$interval(() => {
        count = count = 1;
        console.warn("Trying to load google", count);
        console.log(this.goggleLoaders);
        if (!angular.isUndefined(window.google) || count > 5) {
          resolve();
          this.$interval.cancel(this.goggleLoaders[id]);
          this.goggleLoaders[id] = undefined;
        }
      }, 500);
    });
  }

  setCurrentUser() {
    this.currentUser = this.$auth.getUserData();
  }

  setTotalHoursToJob(shifts) {
    this.setCurrentUser();

    let totalHours = 0;
    let totalMinutes = 0;

    shifts.forEach(function (shift) {
      totalHours = shift.payableHours + totalHours;
      totalMinutes = shift.payableMins + totalMinutes;
    });

    totalHours = totalHours + totalMinutes / 60;
    this.totalPayableHours = totalHours;
    this.estimatedTotalPayables = this.jobble.payPerHour * this.totalPayableHours;
  }
}

JobdescriptionController.$inject = ["$timeout", "$interval", "auth", "tracking", "jobs"];

export default JobdescriptionController;



// WEBPACK FOOTER //
// ./client/app/common/jobdescription/jobdescription.controller.js